import { IFieldEditorAttachment } from '@/shared/types/fieldEditor';
import { getBaseUrl } from '@/shared/utils/url';
import remarkGfm from 'remark-gfm';
import remarkParse from 'remark-parse';
import { unified } from 'unified';
import { visit } from 'unist-util-visit';

export const getUnusedAttachmentsFromMarkdown = ({
  markdown,
  attachments
}: {
  markdown: string;
  attachments: IFieldEditorAttachment[];
}): IFieldEditorAttachment[] => {
  const tree = unified().use(remarkParse).use(remarkGfm).parse(markdown);

  const urlsInMarkdown = new Set<string>();

  visit(tree, (node) => {
    if (node.type === 'image' && node.url) {
      urlsInMarkdown.add(getBaseUrl(node.url));
    }

    if (node.type === 'html' && typeof node.value === 'string' && node.value.includes('<img')) {
      const srcMatch = node.value.match(/src="([^"]+)"/);

      if (srcMatch) {
        urlsInMarkdown.add(getBaseUrl(srcMatch[1]));
      }
    }
  });

  const unusedAttachments = attachments.filter((attachment) => {
    const baseUrl = getBaseUrl(attachment.url);
    return !urlsInMarkdown.has(baseUrl);
  });

  return unusedAttachments;
};
